import { ITreasureSearchResponse } from "../components/TreasureBoundsSearchSelector";

export interface ITreasurePurchaseQuote {
    unitValue: number;
    rate: number;
    date: string;
}

/**
 * PU e taxa de compra do dia. Quando o título não estava à venda (PU de compra 0),
 * usa o par de venda, que é o preço de mercado disponível na data.
 */
export const treasurePurchaseQuote = (quote?: ITreasureSearchResponse | null): ITreasurePurchaseQuote | null => {
    if (!quote) return null;
    if (quote.untr_invstmt_val > 0) {
        return { unitValue: quote.untr_invstmt_val, rate: quote.anul_invstmt_rate, date: quote.date_open };
    }
    if (quote.untr_red_value > 0) {
        return { unitValue: quote.untr_red_value, rate: quote.anul_red_rate, date: quote.date_open };
    }
    return null;
};

/** PU de venda do dia (o que o Tesouro paga no resgate); sem ele, o de compra. */
export const treasureSaleUnitValue = (quote?: ITreasureSearchResponse | null): number | null => {
    if (!quote) return null;
    if (quote.untr_red_value > 0) return quote.untr_red_value;
    if (quote.untr_invstmt_val > 0) return quote.untr_invstmt_val;
    return null;
};
